// Lib
import React, { ReactElement } from 'react';

// Utils
import { getTextContent } from '../../../../common/elements/utils/elementPropertyUtils';

// Hooks
import { useElementTiptapContent } from '../../../../common/tiptap/conversion/elementConversion/useElementTiptapContent';

// Components
import DocumentModalTiptap, { DocumentModalTiptapProps } from './DocumentModalTiptap';

// Types
import { DocumentType } from '../../../../common/tiptap/conversion/elementConversion/elementConversion';

// Styles
import './DocumentModal.scss';

type DocumentModalProps = Omit<DocumentModalTiptapProps, 'textContent'>;

const DocumentModal = (props: DocumentModalProps): ReactElement | null => {
    const { element, elementId, isEditable, spellCheck, isModalView, isPreview, elementInstanceModalRef, permissions } =
        props;

    const textContent = getTextContent(element);
    const tiptapContent = useElementTiptapContent(textContent, elementId, DocumentType.textContent);

    return (
        <DocumentModalTiptap
            element={element}
            textContent={tiptapContent}
            elementId={elementId}
            permissions={permissions}
            isEditable={isEditable}
            spellCheck={spellCheck}
            isModalView={isModalView}
            isPreview={isPreview}
            elementInstanceModalRef={elementInstanceModalRef}
        />
    );
};

export default DocumentModal;
